<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ $t('Plantilla') }}</h2>
			<div class="mb-4">
				<label class="block mb-2" for="name">{{ $t('Nombre') }}</label>
				<input type="text" v-model="template.name" id="name" class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					" />
				<div v-if="$v.template.name.$dirty">
					<div class="text-sm text-red-500 mt-2" v-if="!$v.template.name.required">
						{{ $t('name_required') }}
					</div>
					<div class="text-sm text-red-500 mt-2" v-if="!$v.template.name.maxLength">
						{{ $t('name_validation') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Organizacion') }}</label>
				<select v-model="template.organizationId" class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					">
					<option v-for="(organization, index) in organizations" :value="organization.id" :key="index">
						{{ organization.name }}
					</option>
				</select>
				<div v-if="$v.template.organizationId.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.template.organizationId.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Pais') }}</label>
				<select v-model="template.country" class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					">
					<option v-for="(country, index) in countries" :value="country.code" :key="index">
						{{ country.name }}
					</option>
				</select>
				<div v-if="$v.template.country.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.template.country.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Base_comercial') }}</label>
				<select v-model="template.comercialBase" class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					">
					<option v-for="(comercial, index) in bcomerciales" :value="comercial.id" :key="index">
						{{ comercial.base }}
					</option>
				</select>
				<div v-if="$v.template.comercialBase.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.template.comercialBase.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Tipo_contratacion') }}</label>
				<select v-model="template.contractType" class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					">
					<option v-for="(type, index) in types" :value="type.id" :key="index">
						{{ type.type }}
					</option>
				</select>
				<div v-if="$v.template.contractType.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.template.contractType.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label class="font-normal">{{ $t('Categoria_comercial') }}</label>
				<select v-model="template.comercialCategoryId" class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					">
					<option v-for="(category, index) in categories" :value="category.id" :key="index">
						{{ category.category }}
					</option>
				</select>
				<div v-if="$v.template.comercialCategoryId.$dirty" class="text-left">
					<div class="text-sm text-red-500" v-if="!$v.template.comercialCategoryId.required">
						{{ $t('Campo_requerido') }}
					</div>
				</div>
			</div>
			<div class="mb-4">
				<label for="archivo_adjuntos" class="font-normal">{{
						$t('Archivo')
				}}</label>
				<span class="block">{{ this.file_name }}</span>
				<div>
					<input id="file" class="inputfile" type="file" accept="application/pdf" @change="onFileSelect" />
					<label for="file">
						<div class="flex items-center">
							<i class="fas fa-upload text-sm"></i>
							<span class="ml-3">{{ $t('selected_file') }}</span>
						</div>
					</label>
				</div>
				<div v-if="file == null && id == null" class="text-left">
					<div class="text-sm text-red-500">{{ $t('Campo_requerido') }}</div>
				</div>
			</div>

			<div class="mt-4 flex justify-end">
				<ButtonBlack @click.native="submit">
					<div v-if="loading">
						<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { fetchCountry } from '@/apollo/country'
import {
	insertSingleContractTemplate, updateSingleContractTemplate
} from '@/apollo/mutations/admin/contract_template'
import { fetchOrganizationsSelect } from '@/apollo/organizations'
import { queryComercialBaseList } from '@/apollo/queries/admin/comercial_base'
import { fetchComercialCategory } from '@/apollo/queries/admin/comercial_category'
import { queryContractTemplateByPk } from '@/apollo/queries/admin/contract_template'
import { queryContractTypesList } from '@/apollo/queries/admin/contract_types'
import { single } from '@/mixins'
import uploadFiles from '@/uploadFiles'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
	components: {
		PulseLoader
	},
	mixins: [single],
	apollo: {
		template() {
			const query = queryContractTemplateByPk(this.id)
			query.skip = this.id == null
			return query
		},
		bcomerciales() {
			return queryComercialBaseList()
		},
		types() {
			return queryContractTypesList()
		},
		countries() {
			return fetchCountry()
		},
		categories() {
			return fetchComercialCategory()
		},
		organizations() {
			return fetchOrganizationsSelect()
		}
	},
	data() {
		return {
			s3FilePath: 'contracts_templates/ES/',
			template: {
				name: '',
				organizationId: null,
				comercialCategoryId: null,
				country: null,
				contractType: null,
				comercialBase: null
			},
			file: null,
			file_name: '',
			fileHash: null,
			types: [],
			bcomerciales: [],
			countries: [],
			organizations: [],
			categories: []
		}
	},
	validations() {
		let validations = {
			template: {
				name: {
					required,
					maxLength: maxLength(50)
				},
				organizationId: {
					required,
					maxLength: maxLength(50)
				},
				country: {
					required,
					maxLength: maxLength(50)
				},
				comercialBase: {
					required
				},
				contractType: {
					required
				},
				comercialCategoryId: {
					required
				}
			}
		}
		return validations
	},

	methods: {
		onFileSelect(event) {
			if (event.target.files.length > 0) {
				this.file = event.target.files[0]
				this.file_name = event.target.files[0].name
			}
		},
		async submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				if (!this.file && !this.id) {
					this.stopLoadingState()
					return
				}
				try {
					if (this.file)
						this.fileHash = (await uploadFiles([this.file], this.s3FilePath))[0]
					this.$apollo
						.mutate(
							this.id
								? updateSingleContractTemplate(this.id, this.template)
								: insertSingleContractTemplate({
									...this.template,
									templateUrl: this.fileHash
								})
						)
						.then(() => {
							this.stopLoadingState()
							this.id ? this.$alert("Tu plantilla está actualizada", "¡Enhorabuena!", "success") : this.$alert("Su pantilla ha sido creada", "¡Enhorabuena!", "success")
						})
						.catch(error => {
							this.setError(error)
							this.$alert(error, "Error", "error")
						})
				} catch (err) {
					this.setError(err)
					this.$alert(error, "Error", "error")
				}
			} else {
				this.setError(this.$t('form_validation'))
				this.$alert(this.$t('form_validation'), "Advertencia", "warning")
			}
		}
	}
}
</script>
